<template>
    <div class="login-form" full-height>
        <v-toolbar flat fixed>
            <!-- <v-toolbar-side-icon @click="fn_goBack">
                <img src="../../assets/back-icon.svg" style="margin-top:5px; width:28px"/>
            </v-toolbar-side-icon> -->

            <!-- <v-btn icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-btn> -->
            <v-btn icon @click="fn_goBack"><img src="../../assets/back-icon.svg" alt="back"/></v-btn>

            <v-toolbar-title>{{ $t('otp.toolbarTitle') }}</v-toolbar-title>

            <!-- <v-spacer></v-spacer>

            <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <img src="../../assets/icon_help.svg" style="width:20px"/>
                        </v-btn>
                    </template>
                    <v-list dense nopadding>
                        <v-list-item @click="$root.fn_whatsAppSupport">
                            <v-list-item-action class="mr-2"><img src="../../assets/icon_whatsapp.svg" style="width:20px"/></v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Contact Support</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu> -->
        </v-toolbar>

        <div class="hastoolbar hasfooter">

            <v-card noshadow>
                <v-card-text class="pt-6">

                    <v-form class="form-element">

                        <v-layout align-center nomargin row wrap style="max-width:400px;margin: auto !important;">

                                <p class="title grey-color" style="line-height:28px !important">
                                    {{ $t('otp.codeSentOn') }}<span dark-opacity-color><strong>{{'+91'+$route.query.mobile_number}}</strong></span>
                                </p>

                                <template v-if="changeNumber">
                                    
                                    <v-flex xs12 sm12 md12>
                                       <v-text-field
                                            v-model="Form.OldNumberCode"
                                            mask="######"
                                            :label="$t('otp.enterOtpOld')"
                                            type="tel"
                                            placeholder=" "
                                            v-validate="'required'"
                                            data-vv-name="otp" 
                                            data-vv-as="otp" 
                                            :error-messages="errors.collect('otp')"
                                            required>
                                                
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                       <v-text-field
                                            v-model="Form.NewNumberCode"
                                            mask="######"
                                            :label="$t('otp.enterOtpNew')"
                                            type="tel"
                                            placeholder=" "
                                            v-validate="'required'"
                                            data-vv-name="otp" 
                                            data-vv-as="otp" 
                                            :error-messages="errors.collect('otp')"
                                            required>
                                                
                                        </v-text-field>
                                    </v-flex>

                                </template>


                                <template v-else>
                                  
                                    <!-- <v-flex xs12 sm12 md12 nopadding class="mt-3">
                                       <v-text-field  
                                            v-model="Form.Code"
                                            :maxlength="6"
                                            clearable
                                            hide-details
                                            type="tel"
                                            label="Enter OTP"
                                            placeholder=" "
                                            v-validate="'required|min:6'"
                                            data-vv-name="otp" 
                                            data-vv-as="otp" 
                                            required>
                                                
                                        </v-text-field>
                                    </v-flex> -->

                                    <v-flex xs12 sm12 md12 mb-6 nopadding>
                                       <v-text-field  
                                            v-model="Form.Code"
                                            flat
                                            hide-details
                                            outlined
                                            solo
                                            :maxlength="6"
                                            type="tel"
                                            :placeholder="$t('otp.enterCode')"
                                            v-validate="'required|min:6'"
                                            data-vv-name="otp" 
                                            data-vv-as="otp" 
                                            required>
                                                
                                        </v-text-field>
                                    </v-flex>

                                </template>


                                <!-- <v-flex xs12 sm12 md12 margin-top-ten right-align nopadding>
                                    <v-btn color="primary" nomargin @click="fn_checkValidation">Confirm</v-btn>
                                </v-flex> -->
                                <v-flex xs12 sm12 md12 center-align>
                                    <v-btn color="primary" class="mb-2" style="height:54px;font-size: 1rem;border-radius: 10px;" block @click="fn_checkValidation">{{ $t('otp.confirmBtn') }}</v-btn>
                                    <!-- <div grey-color class="pa-4">By login, I accept the <span @click="fn_openTerms"><u>Terms &amp; Conditions</u></span></div> -->
                                </v-flex>

                                <v-flex xs12 sm12 md12 pt-2 center-align v-if="timeLeft>0">
                                    {{ $t('otp.resendIn') }}{{timeLeft}}{{ $t('otp.secondsSuffix') }}
                                </v-flex>

                            </v-layout>

                    </v-form>
                </v-card-text>
            </v-card>

            <!-- <div class="page-footer" style="bottom:32px;">
                <div class="watermark">
                    <div class="title">BizOps App</div>
                </div>
            </div> -->
        </div>
        
        <v-footer class="bottom-fixed-footer" style="background-color: #fff;">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12 mb-2 center-align @click="$root.fn_whatsAppSupport">
                    <div class="pa-4 pb-0" font14 style="letter-spacing: 0.5px;font-weight: 500;"><span style="color: #4b77be;"><img src="../../assets/icon_support.svg" style="width:20px;margin-bottom: -4px;"/> {{ $t('common.contactSupport') }}</span></div>
                </v-flex>

                <!-- <v-flex xs12 sm12 md12 form-item v-if="timeLeft>0">
                    Resend OTP in: {{timeLeft}} seconds
                </v-flex> -->
            </v-layout>
        </v-footer>

        <v-snackbar :timeout="0" v-model="snackbarSendOtp">{{ $t('otp.resendPrompt') }}
            <v-btn text color="primary" @click.native="fn_getHashKey('resend')">{{ $t('common.okay') }}</v-btn>
        </v-snackbar>

        <v-snackbar :timeout="0" v-model="msgAlert">{{ $t('common.somethingWentWrongAlert') }}
            <v-btn text color="primary" @click.native="fn_checkValidation">{{ $t('common.retry') }}</v-btn>
        </v-snackbar>
    </div>
</template>

<script>

var otpTimer = null;

    export default{
        data(){
            return{
                Form:{"VerificationCodeID":null, "Code":null, "DataDriveLocation":null, "OldNumberCode":null, "NewNumberCode":null, "RequestID":null},
                loading:true,
                changeNumber:false,
                verificationData:null,
                timeLeft:null,
                timeOut:false,
                snackbarSendOtp:false,
                msgAlert:false
            }
        },
        methods:{

            fn_openTerms: function(){
                /*global AndroidRoutingTest*/
                AndroidRoutingTest.openBrowser("https://bizopsapp.com/terms");
            },

            fn_getHashKey: function(type){
                let self = this;
                this.getData('GetHashKey', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(type=='resend'){
                                self.fn_resendOtp(response)
                            }
                            else{
                                self.fn_getOtpFromServer(response);
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast(self.$t('common.somethingWentWrong'))
                        }
                    }
                );
            },

            fn_getOtpFromServer: function(hashKey){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                let self = this;

                this.showLoading(this.$t('common.pleaseWait'));

                let filterObject = {};
                filterObject.PhoneNumber = '91'+this.$route.query.mobile_number;
                filterObject.HashKey = hashKey;
                filterObject.RequestType = 1;

                console.log(JSON.stringify(filterObject));
                // SendOTP
                this.postServerData('LoginSendOTP', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       let data = JSON.parse(response);
                       self.Form.RequestID = data.RequestID;
                       self.fn_setTimer();
                       self.showToast(self.$t('otp.otpSent'));
                       self.hideLoading();
                    }, 
                     onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       
                        if(typeof JSON.parse(error) == 'object'){
                            let response = JSON.parse(error);
                            self.showToast(response.Message);
                            if(response.Message != "OTP limit exceeded for this number! Try after some time."){
                                self.snackbarSendOtp = true;
                            }
                            else{
                                let limitExceededNumberObj = null;
                                if(localStorage.getItem('limitExceededObj')){
                                    limitExceededNumberObj = JSON.parse(localStorage.getItem('limitExceededObj'));
                                }

                                if(limitExceededNumberObj){
                                    if(limitExceededNumberObj.numbers.indexOf(self.$route.query.mobile_number) == -1){
                                        limitExceededNumberObj.dateTime = new Date();
                                        limitExceededNumberObj.numbers.push(self.$route.query.mobile_number);
                                    }
                                }
                                else{
                                    limitExceededNumberObj = {};
                                    limitExceededNumberObj.dateTime = new Date();
                                    limitExceededNumberObj.numbers = [];
                                    limitExceededNumberObj.numbers.push(self.$route.query.mobile_number);
                                }

                                localStorage.setItem('limitExceededObj', JSON.stringify(limitExceededNumberObj));
                            }
                        }
                    }, 
                })
            },

            fn_resendOtp: function(hashKey){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                let self = this;

                this.showLoading(this.$t('common.pleaseWait'));

                let filterObject = {};
                filterObject.HashKey = hashKey;
                filterObject.RequestID = this.Form.RequestID;
                this.snackbarSendOtp = false;
                // ResendOTP
                this.postServerData('LoginResendOTP', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       let data = JSON.parse(response);
                       self.Form.RequestID = data.RequestID;
                       self.fn_setTimer();
                       self.showToast(self.$t('otp.otpSent'));
                       self.hideLoading();
                    }, 
                     onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       self.snackbarSendOtp = true;
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                     }, 
                 })
            },


            fn_verifyOtp: function(){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                let self = this;

                let filterObject = {};
                filterObject.RequestID = this.Form.RequestID;
                filterObject.OTP = this.Form.Code;

                this.showLoading(this.$t('common.pleaseWait'));
                clearInterval(otpTimer);
                this.timeLeft = null;

                this.postServerData('LoginVerifyOTP', filterObject, {
                    onSuccess: function(response){
                       console.log(response);
                       self.showToast(self.$t('otp.otpVerified'));
                       let data = JSON.parse(response);
                       self.fn_verifyCallBack(data.Token);
                       // self.hideLoading();
                    }, 
                     onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       self.timeOut = true;
                       self.snackbarSendOtp = true;
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                     }, 
                 })
            },

            fn_setTimer: function(){
                let self = this;
                this.timeLeft = 90;
                this.timeOut = false;
                otpTimer = setInterval(function(){
                  self.timeLeft -= 1;
                  if(self.timeLeft <= 0){
                    self.snackbarSendOtp = true;
                    clearInterval(otpTimer);
                    self.timeOut = true;
                  }
                }, 1000);
            },

            fn_verifyCallBack: function(response){
                this.$route.params.verifyCallback(response, this.fn_verifyOtpFailureCB);
            },

            fn_setOtp: function(otp){
                console.log(otp);
                if(!this.changeNumber){
                    this.Form.Code = otp;
                    this.fn_verifyOtp();
                }
            },

            fn_checkValidation: function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.fn_verifyOtp(); 
                    }
                    else{
                        this.showToast(this.$t('otp.invalidOtp'));
                    }
                });
            },

            fn_verifyOtpFailureCB: function(){
                this.msgAlert = true;
            },

            fn_goBack: function(){
                this.$router.go(-1);
            }
        },
        mounted: function(){
            console.log(this.$route);

            if(this.$route.params && this.$route.params.dataDriveLocation){
                this.Form.DataDriveLocation = this.$route.params.dataDriveLocation; 
            }

            // Change Number
            if(this.$route.query.oldnumber && this.$route.query.newnumber){
                this.changeNumber = true;
            }

            this.fn_getHashKey();

            window.js_globals.fn_onBackPress = this.fn_goBack;
            window.js_globals.fn_setOtp = this.fn_setOtp;

            let formElement = document.getElementsByClassName("form-element")[0];

            formElement.addEventListener("submit", function(e){
                e.preventDefault();
            });
        }
    }
</script>